export module CommonJS {
    export function jsonToItalianDate(input: string): Date {
        if (input && input != undefined && input != null && input.trim() != '') {
            input = input.split("/").join("-");
            let parts: string[] = input.split("-");
            return new Date(+parts[2], +parts[1] - 1, +parts[0]);
        }
        else return new Date(-62135600400000);
    }

    export function MicrosoftToJsonDate(input: any): Date {
        return eval("new " + input.toString().replace(/\//g,"")) as Date;
    }

    export function dateFromMonth(input: number): Date {
        let s = input.toString();
        let a = s.substr(0, 4);
        let m = s.substr(4, 2);
        return new Date(+a, (+m) - 1, 1);
    }

    export function minDate(): Date {
        return jsonToItalianDate(null);
    }

    export function Now(): Date {
        return jsonToItalianDate(formatDate(new Date()));
    }

    export function ensureDate(input: any): Date {
        let dateString: string = formatDate(input);
        return jsonToItalianDate(dateString);
    }

    export function checkDate(input: any): boolean {
        return ensureDate(input) > minDate();
    }

    export function formatDate(inputString: Date): string {
        let input: Date;
        if (inputString instanceof Date) input = inputString;
        else input = new Date(inputString);
        if (input.getTime() == -62135600400000) return "";
        let day: string = ("0" + input.getDate()).slice(-2);
        let month: string = ("0" + (input.getMonth() + 1)).slice(-2);
        return day + "/" + month + "/" + input.getFullYear();
    }

    export function dateCustomFormat(inputString: Date, format: string): string {
        let input: Date;
        if (inputString instanceof Date) input = inputString;
        else input = new Date(inputString);
        if (input.getTime() == -62135600400000) return "";

        var nm = nomeMeseData(input);
        var nd = nomeGiorno(input);

        let f: string = format;
        f = f.replace(/yyyy/g, input.getFullYear().toString());
        f = f.replace(/yy/g, String(input.getFullYear()).substr(2, 2));
        f = f.replace(/MMMM/g, nm);
        f = f.replace(/mm/g, String(input.getMonth() + 1).padStart(2, '0'));
        f = f.replace(/DDDD/g, nd + " " + String(input.getDate()).padStart(2, '0'));
        f = f.replace(/dd/g, String(input.getDate()).padStart(2, '0'));
        f = f.replace(/hh/g, String(input.getHours()).padStart(2, '0'));
        f = f.replace(/mi/g, String(input.getMinutes()).padStart(2, '0'));
        f = f.replace(/ss/g, String(input.getSeconds()).padStart(2, '0'));        
        return f;
    }

    export function getPreviousWeekDay(input: any, dayNumber: number) {
        if (dayNumber >= 0 && dayNumber < 7) {
            let d = ensureDate(input);
            while (d.getDay() != dayNumber) d.setDate(d.getDate() - 1);
            return d;
        }
        else throw ("Parametro dayNumber non valido (0-6)");
    }

    export function getNextWeekDay(input: any, dayNumber: number) {
        if (dayNumber >= 0 && dayNumber < 7) {
            let d = ensureDate(input);
            while (d.getDay() != dayNumber) d.setDate(d.getDate() + 1);
            return d;
        }
        else throw ("Parametro dayNumber non valido (0-6)");
    }

    export function ellipseString(text: string, len: number = 30): string {
        if (text && text.length > len) text = text.substr(0, len) + "...";
        return text;
    }

    export function titleCase(str) {
        var splitStr = str.toLowerCase().split(' ');
        for (var i = 0; i < splitStr.length; i++) {
            splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        }
        return splitStr.join(' ');
    }

    export function formatTime(inputString: Date): string {
        let input: Date;
        if (inputString instanceof Date) input = inputString;
        else input = new Date(inputString);
        if (input.getTime() == -62135600400000) return "";
        let hours: string = ("0" + input.getHours()).slice(-2);
        let minutes: string = ("0" + (input.getMinutes())).slice(-2);
        return hours + ":" + minutes;
    }

    export function nomeGiorno(input: any): string {
        let d = ensureDate(input);
        var days = ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'];
        return days[d.getDay()];
    }

    export function nomeMeseData(input: any): string {
        let d = ensureDate(input);
        var months = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];
        return months[d.getMonth()];
    }

    export function nomeMese(mese: number): string {
        var months = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];
        return months[mese - 1];
    }
    export function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
      }
      export function addYears(date,years){
        var d = new Date(date);
        var year = d.getFullYear();
        var month = d.getMonth();
        var day = d.getDate();
        var result = new Date(year + 1, month, day);
        return result;
      }
    export function displayTwoDigits(numero: any) {
        return numero.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    export function clone(obj: any): any {
        return (JSON.parse(JSON.stringify(obj)));
    }

    export function cloneProperties(source: any, target: any) {
        for (var k in source) target[k] = source[k];
    }

    export function randomString(length: number): string {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
        for (var i = 0; i < length; i++) text += possible.charAt(Math.floor(Math.random() * possible.length));
        return text;
    }

    export function isMobile(): boolean {
        return window.navigator.userAgent.indexOf("Mobile") > -1;
    }

    export const BootstrapWidth = {
        ExtraSmall: 1,
        Small: 2,
        Medium: 3,
        Large: 4
    }

    export function getBootstrapWidth(): number {
        let displayWidth: number = getDisplayWidth();
        return convertToBootstrapWidth(displayWidth);
    }

    export function convertToBootstrapWidth(larghezza: number): number {
        if (larghezza < 768) return BootstrapWidth.ExtraSmall;
        if (larghezza >= 768 && larghezza < 992) return BootstrapWidth.Small;
        if (larghezza >= 992 && larghezza < 1200) return BootstrapWidth.Medium;
        if (larghezza >= 1200) return BootstrapWidth.Large;
    }

    export function getDisplayWidth(): number {
        return parseInt(getComputedStyle(document.body).width);
    }

    export function getDisplayHeight(): number {
        return parseInt(getComputedStyle(document.body).height);
    }

    export function iPad(): boolean {
        let displayWidth: number = getDisplayWidth();
        let displayHeight: number = getDisplayHeight();
        return ((displayWidth <= 1024 && displayHeight <= 768) || (displayHeight <= 1024 && displayWidth <= 768));
    }

    export function scrollToElement(scrollingToElement: any, fixedHeaderClassName?: string) {
        var distanceScrolled = document.scrollingElement.scrollTop;
        var elemRect = scrollingToElement.getBoundingClientRect();
        var elemViewportOffset = elemRect.top;
        var totalOffset = distanceScrolled + elemViewportOffset;
        let headerMargin = 0;
        if (fixedHeaderClassName) {
            let topbar: any = document.getElementsByClassName(fixedHeaderClassName)[0];
            headerMargin = topbar.offsetHeight + 5;
        }
        scrollTo(0, totalOffset - headerMargin);
    }

    export function smoothScroll(elementSelector) {
        document.querySelector(elementSelector).scrollIntoView({
            behavior: 'smooth',
            block: "start",
            inline: "start"
        });
    }

    export function autoHeightById(divId: string, marginBottom: number) {
        let el: HTMLElement = document.getElementById(divId);
        autoHeight(el, marginBottom);
    }

    export function autoHeightByClass(divCssClass: string, marginBottom: number) {
        let el_array = document.getElementsByClassName(divCssClass);
        if (el_array && el_array.length > 0) Array.from(el_array).forEach(el => autoHeight(el as HTMLElement, marginBottom));
    }

    export function autoHeight(el: HTMLElement, marginBottom: number) {
        var elemRect = el.getBoundingClientRect();
        let displayHeight = getDisplayHeight();
        let elHeight = displayHeight - elemRect.top - marginBottom;
        el.style.height = elHeight.toString() + 'px';
        el.style.maxHeight = elHeight.toString() + 'px';
        el.style.overflowY = "auto";
        window.onresize = function () { autoHeight(el, marginBottom); }

    }

    export function autoHeightCancel(el: HTMLElement) {
        el.style.height = '';
        el.style.maxHeight = '';
        el.style.overflowY = '';
        window.removeEventListener("resize", () => autoHeight(el, 0));
    }

    export function sleep(milliseconds): void {
        var start = new Date().getTime();
        for (var i = 0; i < 1e7; i++) {
            if ((new Date().getTime() - start) > milliseconds) {
                break;
            }
        }
    }

    export function chekEmail(input: string): boolean {
        let result: boolean = false;
        const EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (input && EMAIL_REGEXP.test(input)) result = true;
        return result;
    }

    export function Round(cifra: number, decimali: number): number {
        decimali = Math.round(decimali);
        let c = Math.pow(10, decimali);
        return Math.round(cifra * c) / c;
    }

    export function arrayToMap(array: any[][]): Map<any, any> {
        let m = new Map<any, any>();
        try {
            array.forEach(x => m.set(x[0], x[1]));
        }
        catch{
            m = new Map<any, any>();
        }
        return m;
    }
    export function stringToDate(_date:string,_format:string,_delimiter:string)
    {
            var formatLowerCase=_format.toLowerCase();
            var formatItems=formatLowerCase.split(_delimiter);
            var dateItems=_date.split(_delimiter);
            var monthIndex=formatItems.indexOf("mm");
            var dayIndex=formatItems.indexOf("dd");
            var yearIndex=formatItems.indexOf("yyyy");
            var month=parseInt(dateItems[monthIndex]);
            month-=1;
            var formatedDate = new Date( Number(dateItems[yearIndex]),month,Number(dateItems[dayIndex]));
            return formatedDate;
    }

    export function replaceAll(str:string, find:string, replace:string) {
        return str.replace(new RegExp(find, 'g'), replace);
    }
}


// WEBPACK FOOTER //
// ./src/angular_library/functions/commonjs.ts